// extracted by mini-css-extract-plugin
export var phone = "_56-0";
export var phoneDragging = "_56-1";